export default class StickyElement {
    constructor() {
        this.const = [
            jQuery,
            $(".scroll-to-block")
        ];
        this.variables = [
            '',
            []
        ];
    }

    init() {
        this.stickyElement();
    }

    stickyElement(){
        const [$,stickyElement] = this.const;
        let [activeSection,sections] = this.variables,
        navigateItems = stickyElement.find('ul>li>a');
        navigateItems.each(function() {
            sections.push($(this).attr('href').replace('#', ''));
        });

        if(stickyElement.length) {
            $(window).on('load scroll', function () {
                if ($(this).scrollTop() > 100) {
                    stickyElement.addClass('is-pinned');
                } else {
                    stickyElement.removeClass('is-pinned');
                }
                for(let section of sections){
                    let element = document.getElementById(`${section}`);
                    let elementDetails=element.getBoundingClientRect();
                    if(elementDetails.top<60 && elementDetails.bottom>60){
                        $('.scroll-to-link').removeClass('active');
                        $(`a[href='#${section}']`).addClass('scroll-to-link').addClass('active');
                    }else{
                        continue;
                    }
                }
            });
        }
    }

}